import { RootState } from '../reducers'
import { FavoriteConfig } from '../../api/Favorites/types'

export const favoritesConfigSelector = (state: RootState): FavoriteConfig => state.favoritesConfig.favoritesConfig || undefined
